interface CachedToken {
    token: string;
    expiresAt: number;
}

class TokenCache {
    private static instance: TokenCache;
    private cache: Map<string, CachedToken>;
    private refreshPromise: Promise<string> | null = null;

    private constructor() {
        this.cache = new Map();
    }

    public static getInstance(): TokenCache {
        if (!TokenCache.instance) {
            TokenCache.instance = new TokenCache();
        }
        return TokenCache.instance;
    }

    public getToken(key: string): string | null {
        const cached = this.cache.get(key);
        if (!cached) return null;

        return cached.token;
    }

    public getTokenExpiration(key: string): number | null {
        const cached = this.cache.get(key);
        return cached ? cached.expiresAt : null;
    }

    public isTokenExpiringSoon(key: string, withinMs: number = 10 * 60 * 1000): boolean {
        const expiration = this.getTokenExpiration(key);
        if (!expiration) return true;
        
        return Date.now() + withinMs >= expiration;
    }

    public setToken(key: string, token: string, expiresAt: number): void {
        this.cache.set(key, { token, expiresAt });
    }

    public clearToken(key: string): void {
        this.cache.delete(key);
    }

    public clearAll(): void {
        this.cache.clear();
    }

    public setRefreshPromise(promise: Promise<string> | null): void {
        this.refreshPromise = promise;
    }

    public getRefreshPromise(): Promise<string> | null {
        return this.refreshPromise;
    }
}

export const tokenCache = TokenCache.getInstance();